// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__d0Rgv","noPadding":"Button_noPadding__5sm6n","disabled":"Button_disabled__cAD0h"};